import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export const BlogsSlider = ({ data }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1200, min: 992 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 992, min: 576 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 420, min: 0 },
      items: 1,
    },
  };

  const blogeSlider = () => {
    if (!data || data.length === 0) {
      return null; // Handle empty data case
    }

    return data.map((bloge, i) => (
      <div
        class="blogsCart rounded-3 col-11 m-auto align-items-start"
        key={i}
        style={{ background: "#FEF8F4" }}
      >
        <img
          class=" rounded-top-3"
          src={bloge?.imageUrl}
          style={{
            height: "250px",
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
          alt=""
          loading="lazy" // 👈 yeh important hai
        />
        <div class="p-2 text-start">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <p class="fw-semibold">{bloge?.type}</p>
            </div>
            <div>
              <p>{bloge?.date}</p>
            </div>
          </div>
          <p class="fs-4 fw-bold">{bloge?.title}</p>
          <button className="buttonEffect mb-2">Read More </button>
          <br />
        </div>
      </div>
    ));
  };

  return (
    <Carousel
      responsive={responsive}
      infinite={true}
      autoPlay={false}
      arrows={true}
      autoPlaySpeed={5000}
      showDots={false}
    >
      {blogeSlider()}
    </Carousel>
  );
};
